import { SimpleRect } from '../types';

/**
 * Checks to see if a rect overlaps any others in an array based on left and right properties
 * @param item1 The first item to check
 * @param item2 The second item to check
 * @param offset Optional offset for expanding the size of the rect by the value given
 */
export function isOverlapping(
    item1: SimpleRect,
    item2: SimpleRect,
    { offset = 0 }: { offset?: number } = {},
): boolean {
    return item1.right + offset > item2.left - offset && item1.left - offset < item2.right + offset;
}
